import Vue from "vue";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
Vue.component("html-editor", {
    props: ["value", "hasSource", "toolbarItems", "placeholder", "readOnly"],
    data() {
        return {
            editor: ClassicEditor,
            content: this.value
        }
    },
    computed: {
        editorConfig() {
            let returnValue = {
                height: '10em',
                toolbar: {
                    items: ['bold', 'italic', 'subscript', 'superscript', 'link', '|', 'bulletedList', 'numberedList', 'outdent', 'indent', '|', 'undo', 'redo']
                },
            };



            if (this.hasSource) {
                returnValue = {
                    toolbar: {
                        items: ['bold', 'italic', 'subscript', 'superscript', 'link', '|', 'bulletedList', 'numberedList', 'outdent', 'indent', '|', 'sourceEditing', 'mediaEmbed', '|', 'undo', 'redo']
                    }
                };
            }

            if (this.toolbarItems) {
                returnValue.toolbar = this.toolbarItems.split(',');
            }

            if (this.readOnly) {
                returnValue.toolbar = [];
            }
            returnValue.link = {
                addTargetToExternalLinks: true
            };
            return returnValue;
        },
    },
    methods: {

        handleInput(e) {
            this.$emit('input', this.content)
        }
    },
    mounted() {

    },
    template: `      
	   <ckeditor  :readonly="readOnly" :disabled="readOnly" tag-name="textarea" :editor="editor" @input="handleInput" v-model.lazy="content" @change="handleInput" :config="editorConfig" :placeholder="placeholder"></ckeditor>
	`
});